/**
 * Global search — one endpoint, multiple result types.
 *
 * Fast triage view: typing a name finds the patient + their upcoming
 * appointment + recent invoice in one call. Per-type result lists are
 * capped low (5) so the response is always a quick read.
 */
import { z } from "zod";

export const searchQuerySchema = z.object({
	q: z.string().min(1).max(100),
	limit: z.coerce.number().int().positive().max(20).default(5),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export interface SearchHitPatient {
	type: "patient";
	id: string;
	full_name: string;
	mrn: string;
	phone: string | null;
}

export interface SearchHitAppointment {
	type: "appointment";
	id: string;
	scheduled_at: string;
	status: string;
	patient_id: string;
	patient_name: string;
	doctor_name: string | null;
	title: string | null;
}

export interface SearchHitInvoice {
	type: "invoice";
	id: string;
	invoice_number: string;
	status: string;
	total_amount: number;
	currency: string;
	created_at: string;
	patient_id: string;
	patient_name: string;
}

export type SearchHit =
	| SearchHitPatient
	| SearchHitAppointment
	| SearchHitInvoice;

export interface SearchResult {
	patients: SearchHitPatient[];
	appointments: SearchHitAppointment[];
	invoices: SearchHitInvoice[];
}
